import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import styled from 'src/ui/library/styled';
import intl from 'react-intl-universal';

const styles = (theme, props) => ({
  root: {},
  contentRoot: {
    backgroundColor: '#FFF',
    padding: '6px 16px',
    justifyContent: 'space-between',
  },
  contentMessage: {
    color: theme.colors.eyConfidentGrey,
  },
  contentText: {
    paddingLeft: '8px',
    position: 'relative',
    fontSize: '14px',
    top: '2px',
  },
  contentAction: {
    color: theme.colors.eyConfidentGrey,
    fontWeight: 'bold',
    margin: '0px',
    padding: '0px',
  },
  close: {
    cursor: 'pointer',
  },
});

class ToastBase extends React.Component {
  static propTypes = {
    /** Classname to be applied to <TextField> */
    className: PropTypes.string,
    /** Toast message */
    message: PropTypes.string.isRequired,
    /** Callback function for dismiss action */
    onDismiss: PropTypes.func,
  };

  handleClose = () => {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };

  render() {
    const { classes, message, onDismiss, ...otherProps } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{
          root: classes.root,
        }}
        open={true}
        autoHideDuration={6000}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          classes: {
            root: classes.contentRoot,
            message: classes.contentMessage,
            action: classes.contentAction,
          },
        }}
        message={
          <div id="message-wrapper">
            <div className={'circle-check'} />
            <span className={classes.contentText}>{message}</span>
          </div>
        }
        action={[
          <a aria-label="Close" key={'close'} className={classes.close} onClick={this.handleClose}>
            <span>{intl.get('messaging.notifications.dismiss')}</span>
          </a>,
        ]}
        {...otherProps}
      />
    );
  }
}

export { ToastBase };
export default styled(ToastBase)(styles);
